
export const addImpact = (state, payload)=> {
  state.impact = payload;
};
export const updateImpact = (state, payload)=>{
  //No udate gui at the mo but write update or new code anyhow
  const impactId = payload.id;
  const objectInArray = (element)=>element.id == impactId;
  const arrayIndex = state.impact.findIndex(objectInArray);
  if (arrayIndex == -1){
    // this is a new impact push it to the array in store
    state.impact.push(payload);
  }else{
    // replace the existing item in the array
    state.impact.splice(arrayIndex,1,payload);
  }

};

export const personNotes = (state, payload) => {
  state.personNotes = payload;
};

export const personNotesUpdate = (state, payload) => {
  // Identify the index of this note
  const noteId = payload.id;
  // the function that will be called by arrayIndex to test the id of the note
  const objectInArray = (element) => element.id == noteId;
  // will return the index if it exists else -1 if if doesnt
  const arrayIndex = state.personNotes.findIndex(objectInArray);
  if (arrayIndex == -1) {
    // there is no matching index in the array it must be new just unshift to top
    state.personNotes.unshift(payload);
  } else {
    // there is a matching object in the array update this. We only need to do the email address
    // but we will do the id and person id also so we can use this for other use cases
    state.personNotes.splice(arrayIndex, 1, payload);
  }
};

export const removeFromPeopleAttending = (state, payload) => {
  // find the sessionId in the peopleAttendingToday array of objects and pop it out
  const sessionId = payload.id;
  const objectInArray = (element) => element.id == sessionId;
  const arrayIndex = state.peopleAttendingToday.findIndex(objectInArray);
  if (arrayIndex != -1) {
    state.peopleAttendingToday.splice(arrayIndex, 1);
  }
};

export const addToPeopleAttending = (state, payload) => {
  //let item;
  // if (Array.isArray(payload)) {
  //   for (item in payload) {
  //     state.peopleAttendingToday.push(payload[item]);
  //   }
  if (Array.isArray(payload)) {
    state.peopleAttendingToday = payload;
  } else {
    state.peopleAttendingToday.push(payload);
  }
};

export const projectDelete = (state) => {
  // clear the project and project options state objects
  state.projectOptions = {};
  state.project = {};
};

export const projectOptions = (state, payload) => {
  //eslint-disable-next-line no-console
  //console.log("commiting options mutation")
  state.projectOptions = payload;
};

export const project = (state, payload) => {
  //eslint-disable-next-line no-console
  //console.log(payload);
  state.project = payload;
  // As we add projects in a modal on the projectList component we want to update the projectList if it exists
  // we need to be able to distinguish between an edited project that exists in the array
  // and a new project that also uses this mutation
  if (state.projectList != null) {
    const projectId = payload.id;
    // the function that will be called by arrayIndex to test the id of the email
    const objectInArray = (element) => element.id == projectId;
    // will return the index if it exists else -1 if if doesnt
    const arrayIndex = state.projectList.results.findIndex(objectInArray);
    if (arrayIndex == -1) {
      // there is no matching index in the array just push it to the bottom
      state.projectList.results.push(payload);
    } else {
      // there is a matching object in the array update this. We only need to do the email address
      // but we will do the id and person id also so we can use this for other use cases
      state.projectList.results.splice(arrayIndex, 1, payload);
    }
  }
};

export const projectAliasesLive = (state, payload)=>{
  state.projectAliasesLive = payload.results;
};

export const projectAliasDelete = (state, payload) => {
  // project aliases are part of a projects object
  const aliasId = payload;
  //find the index in the array that contians this alias this is the callback function for array inded
  const objectInArray = (element) => element.id == aliasId;
  const arrayIndex = state.project.aliases.findIndex(objectInArray);
  state.project.aliases.splice(arrayIndex, 1);
};

export const projectOutcomeDelete = (state, payload) => {
  // project aliases are part of a projects object
  const outcomeId = payload;
  //find the index in the array that contians this alias this is the callback function for array inded
  const objectInArray = (element) => element.id == outcomeId;
  const arrayIndex = state.project.outcomes.findIndex(objectInArray);
  state.project.outcomes.splice(arrayIndex, 1);
};

export const projectAliasUpdate = (state, payload) => {
  // project aliases are part of a projects object
  const aliasId = payload.id;
  //find the index in the array that contians this alias this is the callback function for array inded
  const objectInArray = (element) => element.id == aliasId;
  const arrayIndex = state.project.aliases.findIndex(objectInArray);
  state.project.aliases.splice(arrayIndex, 1);
};

export const projectList = (state, payload) => {
  state.projectList = payload;
};

export const peopleList = (state, payload) => {
  state.peopleList = payload;
};

export const djangoToken = (state, payload) => {
  state.djangoToken = payload;
};

export const addedFriend = (state, payload) => {
  state.dataFromSearch.addedFriend = payload;
};

export const reportData = (state, payload) => {
  state.reportData = payload;
};

export const preferedContactsUpdate = (state, payload) => {
  state.person.preferedEmail = payload.list_prefered_email;
  state.person.preferedPhone = payload.list_prefered_phone;
  // if emergency contact data in payload update it.
  if (payload.emergency_contact_detail) {
    state.person.emergencyContact = payload.emergency_contact_detail;
  }
};

export const person = (state, payload) => {
  // when an null medical conditions is patched it sets to a string value of null ....put this right
  if (payload.medicalConditions == "null") {
    payload.medicalConditions = null;
  }
  state.person = payload;
};

export const axiosError = (state, payload) => {
  //eslint-disable-next-line no-console
  //console.log(payload, typeof payload);
  if (payload == "Error: Request failed with status code 401") {
    state.axiosError = "Unauthorised Please Login";
  } else {
    state.axiosError = payload;
  }
};
export const personEmergencyPhone = (state, payload) => {
  state.person.emergencyContact.preferedPhone = payload;
};

export const personUpdate = (state, payload) => {
  // when an null medical conditions is patched it sets to a string value of null ....put this right
  if (payload.medicalConditions == "null") {
    payload.medicalConditions = null;
  }
  state.person = payload;
};

export const email = (state, payload) => {
  state.email = payload;
};

export const emailUpdate = (state, payload) => {
  // we need to be able to distinguish between an edited email that exists in the array
  // and a new email that alos uses this mutation
  const emailId = payload.id;
  // the function that will be called by arrayIndex to test the id of the email
  const objectInArray = (element) => element.id == emailId;
  // will return the index if it exists else -1 if if doesnt
  const arrayIndex = state.email.findIndex(objectInArray);
  if (arrayIndex == -1) {
    // there is no matching index in the array just unshift it to the top
    state.email.unshift(payload);
  } else {
    // there is a matching object in the array update this. We only need to do the email address
    // but we will do the id and person id also so we can use this for other use cases
    state.email.splice(arrayIndex, 1, payload);
  }
};

export const emailDelete = (state, payload) => {
  // deletes return no data so we pass the id of the deleted email as the payload
  // find the index of the array that contains the email id
  const objectInArray = (element) => element.id == payload;
  const arrayIndex = state.email.findIndex(objectInArray);
  // now remove from array
  state.email.splice(arrayIndex, 1);
};

export const phone = (state, payload) => {
  state.phone = payload;
};

export const phoneUpdate = (state, payload) => {
  // we need to be able to distinguish between an edited PHONE that exists in the array
  // and a new PHONE that also uses this mutation
  const phoneId = payload.id;
  // the function that will be called by arrayIndex to test the id of the email
  const objectInArray = (element) => element.id == phoneId;
  // will return the index if it exists else -1 if if doesnt
  const arrayIndex = state.phone.findIndex(objectInArray);
  if (arrayIndex == -1) {
    // there is no matching index in the array just unshift it to the top
    state.phone.unshift(payload);
  } else {
    // there is a matching object in the array update this. We only need to do the email address
    // but we will do the id and person id also so we can use this for other use cases
    state.phone.splice(arrayIndex, 1, payload);
  }
};

export const phoneDelete = (state, payload) => {
  // deletes return no data so we pass the id of the deleted email as the payload
  // find the index of the array that contains the email id
  const objectInArray = (element) => element.id == payload;
  const arrayIndex = state.phone.findIndex(objectInArray);
  // now remove from array
  state.phone.splice(arrayIndex, 1);
};

export const showHideElement = (state, payload) => {
  const elementName = payload.elementName;
  const elementValue = payload.elementValue;
  const evalString =
    "state.showHideElement." + elementName + "=" + elementValue;
  eval(evalString);
};

export const fnf = (state, payload) => {
  state.fnf = payload;
};

export const fnfUpdate = (state, payload) => {
  // we need to be able to distinguish between an edited fnf that exists in the array
  // and a new fnf that also uses this mutation
  const fnfId = payload[0].id;
  // the function that will be called by arrayIndex to test the id of the email
  const objectInArray = (element) => element.id == fnfId;
  // will return the index if it exists else -1 if if doesnt
  const arrayIndex = state.fnf.findIndex(objectInArray);
  if (arrayIndex == -1) {
    // there is no matching index in the array just unshift it to the top
    state.fnf.unshift(payload[0]);
  } else {
    // there is a matching object in the array update this. We only need to do the email address
    // but we will do the id and person id also so we can use this for other use cases
    state.fnf.splice(arrayIndex, 1, payload[0]);
  }
};

export const fnfOptions = (state, payload) => {
  state.fnfOptions = payload.actions.POST.typeOfFriend.choices;
};

export const fnfEditData = (state, payload) => {
  state.fnfEditData = payload;
};

export const fnfDelete = (state, payload) => {
  // deletes return no data so we pass the id of the deleted email as the payload
  // find the index of the array that contains the email id
  const objectInArray = (element) => element.id == payload;
  const arrayIndex = state.fnf.findIndex(objectInArray);
  // now remove from array
  state.fnf.splice(arrayIndex, 1);
};

export const impactPayload = (state,payload)=>{
  state.impactPayload = payload;
}

export const toggleLoadingData = (state)=>{
  state.loadingData = !state.loadingData
}
